import script from "./fw23_setting.vue?vue&type=script&setup=true&lang=js"
export * from "./fw23_setting.vue?vue&type=script&setup=true&lang=js"

import "./fw23_setting.vue?vue&type=style&index=0&id=7e8cb7ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e8cb7ee"]])

export default __exports__